"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CohortPlansDataTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * CohortPlansDataTable - TanStack Table for cohort degree plans
 *
 * Columns: Acad. Program, Specialization, Track, Start Term, View Plans, Mass Update
 * Matches Angular's cohort-plans.component.html
 */
const react_1 = __importStar(require("react"));
const react_table_1 = require("@tanstack/react-table");
const Button_1 = require("./Button");
require("./CohortPlansDataTable.scss");
const columnHelper = (0, react_table_1.createColumnHelper)();
const CohortPlansDataTable = ({ plans, onViewPlans, onMassUpdate, loading = false, }) => {
    const [sorting, setSorting] = react_1.default.useState([]);
    const data = (0, react_1.useMemo)(() => {
        return plans.map((plan) => {
            var _a, _b, _c, _d, _e, _f;
            // Extract start term from first term sorted by startDate
            const sortedTerms = [...(plan.terms || [])].sort((a, b) => {
                var _a, _b;
                const dateA = ((_a = a.term) === null || _a === void 0 ? void 0 : _a.startDate) ? new Date(a.term.startDate).getTime() : 0;
                const dateB = ((_b = b.term) === null || _b === void 0 ? void 0 : _b.startDate) ? new Date(b.term.startDate).getTime() : 0;
                return dateA - dateB;
            });
            const firstTerm = sortedTerms[0];
            return {
                plan,
                academicProgramName: ((_a = plan.academicProgram) === null || _a === void 0 ? void 0 : _a.name) || ((_b = plan.cohort) === null || _b === void 0 ? void 0 : _b.name) || 'N/A',
                specialization: ((_c = plan.cohort) === null || _c === void 0 ? void 0 : _c.specialization) || '',
                track: ((_d = plan.cohort) === null || _d === void 0 ? void 0 : _d.track) || '',
                startTerm: ((_e = firstTerm === null || firstTerm === void 0 ? void 0 : firstTerm.term) === null || _e === void 0 ? void 0 : _e.name) || ((_f = firstTerm === null || firstTerm === void 0 ? void 0 : firstTerm.term) === null || _f === void 0 ? void 0 : _f.clientName) || 'N/A',
            };
        });
    }, [plans]);
    const columns = (0, react_1.useMemo)(() => [
        columnHelper.accessor('academicProgramName', {
            header: 'Acad. Program',
            cell: (info) => info.getValue(),
            enableSorting: true,
        }),
        columnHelper.accessor('specialization', {
            header: 'Specialization',
            cell: (info) => info.getValue() || '\u2014',
            enableSorting: true,
        }),
        columnHelper.accessor('track', {
            header: 'Track',
            cell: (info) => info.getValue() || '\u2014',
            enableSorting: true,
        }),
        columnHelper.accessor('startTerm', {
            header: 'Start Term',
            cell: (info) => info.getValue(),
            enableSorting: true,
        }),
        columnHelper.display({
            id: 'viewPlans',
            header: 'View Plans',
            cell: ({ row }) => ((0, jsx_runtime_1.jsx)(Button_1.Button, { size: "small", variant: "ghost", onClick: () => onViewPlans(row.original.plan), "aria-label": `View plans for ${row.original.academicProgramName}`, children: "View/Add" })),
        }),
        columnHelper.display({
            id: 'massUpdate',
            header: 'Mass Update',
            cell: ({ row }) => ((0, jsx_runtime_1.jsx)(Button_1.Button, { size: "small", variant: "secondary", onClick: () => onMassUpdate(row.original.plan), "aria-label": `Mass update ${row.original.academicProgramName}`, children: "Mass Update" })),
        }),
    ], [onViewPlans, onMassUpdate]);
    const table = (0, react_table_1.useReactTable)({
        data,
        columns,
        state: { sorting },
        onSortingChange: setSorting,
        getCoreRowModel: (0, react_table_1.getCoreRowModel)(),
        getSortedRowModel: (0, react_table_1.getSortedRowModel)(),
    });
    if (loading) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "cohort-data-table__loading", children: (0, jsx_runtime_1.jsx)("p", { children: "Loading cohort plans..." }) }));
    }
    if (plans.length === 0) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "cohort-data-table__empty", children: (0, jsx_runtime_1.jsx)("p", { children: "No cohort degree plans found for this organization." }) }));
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "cohort-data-table", children: (0, jsx_runtime_1.jsxs)("table", { className: "cohort-data-table__table", children: [(0, jsx_runtime_1.jsx)("thead", { children: table.getHeaderGroups().map((headerGroup) => ((0, jsx_runtime_1.jsx)("tr", { children: headerGroup.headers.map((header) => ((0, jsx_runtime_1.jsxs)("th", { className: header.column.getCanSort() ? 'cohort-data-table__th--sortable' : '', onClick: header.column.getToggleSortingHandler(), style: { cursor: header.column.getCanSort() ? 'pointer' : 'default' }, children: [header.isPlaceholder
                                    ? null
                                    : (0, react_table_1.flexRender)(header.column.columnDef.header, header.getContext()), header.column.getIsSorted() === 'asc' && ' \u25B2', header.column.getIsSorted() === 'desc' && ' \u25BC'] }, header.id))) }, headerGroup.id))) }), (0, jsx_runtime_1.jsx)("tbody", { children: table.getRowModel().rows.map((row) => ((0, jsx_runtime_1.jsx)("tr", { children: row.getVisibleCells().map((cell) => ((0, jsx_runtime_1.jsx)("td", { children: (0, react_table_1.flexRender)(cell.column.columnDef.cell, cell.getContext()) }, cell.id))) }, row.id))) })] }) }));
};
exports.CohortPlansDataTable = CohortPlansDataTable;
exports.default = exports.CohortPlansDataTable;
